export const Grid = {
  DesktopWide: '1440px',
  DesktopNarrow: '1220px',
}
